import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'RENTAL_RULESET' });



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/handlers.js